import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchDepartmentsList } from "./departmentsThunks";
import { Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DepartmentList from "./components/DepartmentList";

const { Title } = Typography;

const Departments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { departments } = useSelector((state) => state.departments);

  useEffect(() => {
    dispatch(fetchDepartmentsList());
  }, [dispatch]);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="departments-back-button"
        />
        <Title level={2} style={{ margin: 0 }}>Departments</Title>
      </div>
      <DepartmentList departmentsList={departments} />
    </>
  );
};

export default Departments;
